<template>
  <section v-show="!isSpecial">
    <div class="section_title">
      <img src="@/assets/img/cart_sub.jpg" />
      <h1 class="">ご注文</h1>
    </div>
    <div class="detail-cart box-p-20 mt-5">
      <h2 class="mb-5" v-html="message1"></h2>
      <div v-show="htmlPayment" v-html="htmlPayment"></div>
      <p class="text-center" v-html="message2"></p>
    </div>
  </section>

  <!-- モバイル＆現金払いのみの場合、ここに伝票を表示する -->
  <!-- その際、ヘッダーとフッターは除外する -->
  <div v-show="isSpecial" v-html="htmlVoucher" style="display: none; background-color: white" class="voucher"></div>
</template>

<script>
import axios from "axios";
import Request from "@/modules/Request";
let request = new Request();

export default {
  data() {
    return {
      paymentMethod: "",
      htmlPayment: "",
      htmlVoucher: "",
      orderNo: "",
      message1: "ご注文ありがとうございました。",
      message2: "準備が整い次第発送いたします。<br />詳しくは、メールをご確認ください。",

      isSpecial: false,

      // テスト用のパラメータ
      sod: "",
      pid: "",
      uu: "",
    };
  },
  mounted() {
    // クエリパラメータからクレジット決済を経由した結果を取得
    let result = this.$route.query.result; // クエリがなければ1
    this.complete(result);

    // テスト用のパラメータを格納
    this.sod = this.$route.query.sod;
    this.pid = this.$route.query.pid;
    this.uu = this.$route.query.test;
    window.scroll(0, 0);
  },
  methods: {
    complete(result) {
      let postParams = [];
      let requestParams = request.createParams(
        "webMdlOrder",
        "getOrderComplate",
        postParams
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.isSpecial = data.Special;
          this.orderNo = data.OrderNumber;

          if (result === "" || result === undefined) { // クレジット決済以外
            // 決済完了パターン、クレジット以外は前画面で注文を完了している
            if (this.isSpecial) {
              this.$store.commit("hideLayout");
              this.htmlVoucher = data.html;
            } else {
              this.htmlPayment = data.html;
            }
          } else { // resultがあればクレジット決済
            if (result == 0) { // カード決済に失敗
              this.message1 = "カード決済に失敗しました。";
              this.message2 = "大変お手数ですが、再度ご注文をお願いいたします。";
            } else {
              // クレジット決済成功

              // 開発環境の場合は決済結果通知をサーバへ通知する（必ず成功する)
              if (process.env.NODE_ENV == "development") {
                axios.get(process.env.VUE_APP_CREDIT_URL, {
                  params: {
                    job: "CAPTURE",
                    uu: this.uu,
                    pid: this.pid,
                    sod: this.sod,
                    rst: 1
                  }
                }).then((data) => {
                  console.log(data);
                });
              }
            }
          }
        });
    },
  },
};
</script>

